import {parseJSON} from "./utils";

function getStorage(name: "localStorage" | "sessionStorage") {
  try {
    return globalThis[name] ?? null;
  } catch {
    return null;
  }
}

export function getItem(key: string) {
  return parseJSON(getStorage("localStorage")?.getItem(key) || "null");
}

export function removeItem(key: string) {
  getStorage("localStorage")?.removeItem(key);
}

export function setItem(key: string, value: unknown) {
  getStorage("localStorage")?.setItem(key, JSON.stringify(value));
}

export function clearStorage() {
  getStorage("localStorage")?.clear();
}

export function getTemporaryItem(key: string) {
  return parseJSON(getStorage("sessionStorage")?.getItem(key) || "null");
}

export function removeTemporaryItem(key: string) {
  getStorage("sessionStorage")?.removeItem(key);
}

export function setTemporaryItem(key: string, value: unknown) {
  getStorage("sessionStorage")?.setItem(key, JSON.stringify(value));
}

export function clearTemporaryStorage() {
  getStorage("sessionStorage")?.clear();
}
